<template>
  <woot-modal
    :show="true"
    :on-close="onClose"
    size="!w-[522px] !max-w-[95vw] !rounded-[12px]"
  >
    <div class="flex flex-col p-6 gap-6">
      <div>
        <div class="flex items-center gap-2 mb-2">
          <span class="material-symbols-outlined text-[22px] text-[#323431]">
            delete
          </span>
          <h3 class="text-lg font-semibold text-[#323431]">
            {{ $t('TEAMS_SETTINGS.DELETE_MODAL.TITLE', { teamName }) }}
          </h3>
        </div>
        <p
          v-dompurify-html="
            $t('TEAMS_SETTINGS.DELETE_MODAL.DESC', { teamName })
          "
          class="text-sm text-[#475569]"
        />
      </div>

      <div>
        <label class="block text-sm font-normal text-[#374151] mb-1">
          {{ $t('TEAMS_SETTINGS.DELETE_MODAL.CONFIRM_LABEL') }}
        </label>
        <input
          v-model.trim="confirmName"
          type="text"
          class="w-full h-11 rounded-[8px] border border-[#9CA3AF] px-3 text-sm !m-0"
          :placeholder="$t('TEAMS_SETTINGS.DELETE_MODAL.PLACEHOLDER')"
          @keyup.enter="onConfirm"
        />
      </div>

      <div class="flex items-center justify-end gap-3">
        <button
          type="button"
          class="button-ghost px-5 py-3 text-sm rounded-[5px]"
          style="border: 1px solid #e5e7eb"
          @click="onClose"
        >
          {{ $t('TEAMS_SETTINGS.DELETE_MODAL.CANCEL') }}
        </button>
        <button
          type="button"
          class="px-5 py-3 text-sm rounded-[5px]"
          :class="canDelete ? 'text-white' : 'cursor-not-allowed'"
          :style="
            canDelete
              ? 'background:#EF4444'
              : 'background:#E5E7EB; color:#9CA3AF'
          "
          :disabled="!canDelete"
          @click="onConfirm"
        >
          {{ $t('TEAMS_SETTINGS.DELETE_MODAL.DELETE') }}
        </button>
      </div>
    </div>
  </woot-modal>
</template>

<script>
export default {
  props: {
    team: {
      type: Object,
      default: () => ({}),
    },
    onClose: {
      type: Function,
      required: true,
    },
  },
  data() {
    return {
      confirmName: '',
    };
  },
  computed: {
    teamName() {
      return this.team.name;
    },
    canDelete() {
      return (
        !!this.confirmName &&
        this.confirmName.trim() === (this.team.name || '').trim()
      );
    },
  },
  methods: {
    onConfirm() {
      if (!this.canDelete) {
        return;
      }
      this.$emit('confirm');
    },
  },
};
</script>
